"use client";

import { useState, useEffect } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Phone, MessageSquare, Mail } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function SalesTeam() {
  const [isZh, setIsZh] = useState(false);
  useEffect(() => {
    const checkLang = () => {
      setIsZh(localStorage.getItem("elite-language") === "zh-Hant");
    };
    checkLang();
    window.addEventListener("storage", checkLang);
    return () => window.removeEventListener("storage", checkLang);
  }, []);
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const team = [{
    name: "KM",
    role: isZh ? "銷售總監" : "Sales Director",
    email: "km@elitegroup.com.hk"
  }, {
    name: "Mark",
    role: isZh ? "銷售經理" : "Sales Manager",
    email: "mark@elitegroup.com.hk"
  }, {
    name: "Emma",
    role: isZh ? "銷售經理" : "Sales Manager",
    email: "emma@elitegroup.com.hk"
  }, {
    name: "Ken",
    role: isZh ? "銷售主管" : "Sales Executive",
    email: "ken@elitegroup.com.hk"
  }];
  return <section data-section-id="17051" id="regional-sales-team" className="bg-background text-foreground py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-12">
        <div ref={header.ref} className={`grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 mb-20 md:mb-28 transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="md:col-span-7">
            <h2 className="font-default font-bold text-foreground" style={{
            fontSize: "clamp(3rem, 8vw, 9rem)",
            letterSpacing: "-0.035em",
            lineHeight: "0.88"
          }}>
              {isZh ? <>
                  我們的{" "}
                  <span className="italic font-default" style={{
                color: "var(--primary)"
              }}>團隊</span>
                  。
                </> : <>
                  Our{" "}
                  <span className="italic font-default" style={{
                color: "var(--primary)"
              }}>team</span>
                  .
                </>}
            </h2>
          </div>
          <div className="md:col-span-5 md:pt-4">
            <p className="font-default text-foreground/85" style={{
            fontSize: "clamp(1.125rem, 1.35vw, 1.375rem)",
            lineHeight: "1.5",
            letterSpacing: "-0.005em"
          }}>
              {isZh ? "專業團隊致力於將您的產品構想與我們的製造實力無縫對接。精通全球合規標準與供應鏈物流管理。" : "Dedicated professionals bridging the gap between your product vision and our manufacturing capabilities. Experts in global compliance and supply chain logistics."}
            </p>
          </div>
        </div>

        <div className="mb-12">
          <div className="p-8 md:p-10 rounded-lg" style={{
          backgroundColor: "#FDFBF4"
        }}>
            <h3 className="font-default font-bold mb-6 text-xl uppercase tracking-wider" style={{
            color: "#E9B14F"
          }}>
              {isZh ? "直接聯絡" : "Direct Contact"}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 mt-1" style={{
                color: "#E9B14F"
              }} />
                <div>
                  <p className="font-default font-semibold text-foreground">
                    {isZh ? "電話支援" : "Phone Support"}
                  </p>
                  <div className="mt-2 space-y-1">
                    <p className="text-lg">+852 56262785</p>
                    <p className="text-lg">+852 94396741</p>
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <MessageSquare className="w-6 h-6 mt-1" style={{
                color: "#E9B14F"
              }} />
                <div>
                  <p className="font-default font-semibold text-foreground">
                    {isZh ? "微信號" : "WeChat ID"}
                  </p>
                  <p className="mt-2 text-lg font-medium" style={{
                  color: "#E9B14F"
                }}>Elite_Emma</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {team.map((member, i) => <div key={member.name} data-index={i} className="p-8 rounded-lg transition-transform duration-300 hover:-translate-y-1" style={{
          backgroundColor: "#FDFBF4"
        }}>
              <div className="flex flex-col h-full">
                <h4 className="font-default" style={{
              fontSize: "clamp(1.5rem, 2vw, 1.875rem)",
              fontWeight: 700,
              letterSpacing: "-0.02em",
              lineHeight: "1.2",
              color: "#E9B14F"
            }}>
                  {member.name}
                </h4>

                <p className="mt-2 font-default text-muted-foreground font-medium" style={{
              fontSize: "1rem",
              letterSpacing: "0.01em",
              lineHeight: "1.45"
            }}>
                  {member.role}
                </p>

                <div className="mt-6 pt-6 border-t border-black/5">
                  <Link to={`mailto:${member.email}`} className="inline-flex items-center gap-2 text-gray-800 underline underline-offset-4 hover:text-black transition-colors" style={{
                fontSize: "0.9375rem"
              }}>
                    <Mail className="w-4 h-4" />
                    {member.email}
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}